import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Category2, Call, Chart2, RouteSquare, Clock, Setting2 } from "iconsax-react";
import BetaTag from "../../features/calling/components/BetaTag";
import PanelHeading, { SUBTITLE_HEIGHT } from "../Navbar/PanelHeading";
import SidebarNavList from "../Navbar/SidebarNavList";

export const CALLS_SECTIONS = [
  { key: "overview", label: "Overview", Icon: Category2, description: "Call volume, duration and outcomes at a glance." },
  { key: "logs", label: "All Calls", Icon: Call, description: "Browse every inbound and outbound call." },
  { key: "reports", label: "Reports", Icon: Chart2, description: "Per-agent call performance and talk time." },
  { key: "routing", label: "Routing", Icon: RouteSquare, description: "Decide who an incoming call rings first.", requiresEdit: true },
  { key: "office-hours", label: "Office Hours", Icon: Clock, description: "Set when calls are actually answered.", requiresEdit: true },
  { key: "settings", label: "Settings", Icon: Setting2, description: "Configure calling behavior for this account.", requiresEdit: true },
];

// Rebuilt 2026-09-10 to match Inbox's rail exactly (same shared components as
// Settings'/Reports'/Broadcasts' sidebars) -- was its own hand-rolled
// ListItem list (MUI icons, action.selected background, 220px width).
export default function CallsSubNav({ selected, onSelect, canEdit }) {
  const theme = useTheme();
  const sections = canEdit ? CALLS_SECTIONS : CALLS_SECTIONS.filter((s) => !s.requiresEdit);

  const items = sections.map((section) => {
    const isSelected = selected === section.key;
    const Icon = section.Icon;
    return {
      key: section.key,
      label: section.label,
      selected: isSelected,
      onClick: () => onSelect(section.key),
      icon: (
        <Icon
          size="100%"
          color={isSelected ? theme.palette.text.primary : "currentColor"}
          variant={isSelected ? "Bold" : "Linear"}
        />
      ),
    };
  });

  return (
    <Box
      sx={{
        width: "280px",
        flexShrink: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "background.default",
        borderRight: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      {/* BetaTag moved into the header's action slot (was next to the old
          hand-rolled title) -- still visible, same meaning, no new component
          needed. Height forced to match the content pane's header (which has
          a subtitle, this one doesn't), same fix as every other sidebar
          rebuilt this pass. */}
      <PanelHeading title="Calls" variant="narrow" action={<BetaTag />} sx={{ height: SUBTITLE_HEIGHT }} />
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        <SidebarNavList items={items} />
      </Box>
    </Box>
  );
}
